import React from 'react';
import { useNavigate } from 'react-router-dom';

const slugify = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

const Cell = ({ side, data }) => {
  const empty = !data || !data.p;
  return (
    <div className={side === 'back' ? 'back bl-box' : 'bl-box lay'}>
      <span className="d-block bet-button-price">
        {empty ? ' - ' : ` ${data.p} `}<em>{empty ? '-' : (data.v || '')}</em>
      </span>
    </div>
  );
};

const Market = ({ col }) => (
  <div className="col-md-4 col-4">
    <div className="h-backLay">
      <Cell side="back" data={col && col.b} />
      <Cell side="lay" data={col && col.l} />
    </div>
  </div>
);

export default function MatchRow({ row }) {
  const ic = row.ic || [];
  const navigate = useNavigate();
  const stop = (e) => e.preventDefault();
  const openMatch = (e) => { e.preventDefault(); navigate(`/match/${slugify(row.t)}`); };
  return (
    <div className="bet-table-row">
      <div className="row">
        <div className="col-md-6">
          <div className="game-box">
            <div className="game-left-col">
              <div className="game-name">
                <a href={`/match/${slugify(row.t)}`} onClick={openMatch}>
                  <p className="team-name text-left">{row.t} </p>
                  <p className="team-name text-left team-event">({row.s})</p>
                </a>
              </div>
              {row.live ? <div className="game-date inplay"><span>Live</span></div> : null}
              <div className="game-date">
                <p className="mb-0 day text-left">{row.d}</p>
                <p className="mb-0 day text-left">{row.tm}</p>
              </div>
            </div>
            <div className="game-icons">
              <div className="icon-tv">
                {ic.includes('tv') && <a href="#!" onClick={stop}><i className="bi bi-tv" /></a>}
                {ic.includes('fancy') && <span className="game-custom">F</span>}
                {ic.includes('bm') && <span className="game-bm">BM</span>}
                {ic.includes('p') && <span className="game-bm bg-success">P</span>}
              </div>
            </div>
            <a href="#!" className="add-pin" onClick={stop}><i className="bi bi-pin" /></a>
          </div>
        </div>
        <div className="col-md-6 text-center">
          <div className="row g-0">
            <Market col={row.o[0]} />
            <Market col={row.o[1]} />
            <Market col={row.o[2]} />
          </div>
        </div>
      </div>
    </div>
  );
}
